<template>
  <v-card class="main-content-card" flat>
    <v-toolbar flat>
      <v-toolbar-title>个人项目到款</v-toolbar-title>
      <span class="subheading ml-2">|</span>
      <v-btn round small color="primary" class="ml-3"
             target="_blank"
             :href="excelUrl">
        <v-icon dark small>table_chart</v-icon>导出Excel
      </v-btn>
    </v-toolbar>

    <v-divider/>

    <!-- 检索功能区 -->
    <v-container fluid grid-list-md class="px-4" style="background-color: rgba(245, 245, 245, 0.6);">
      <v-layout row wrap>
        <v-flex d-flex xs10>
          <v-layout row wrap>
            <v-flex xs12 sm3>
              <v-menu
                  ref="refGrantDateStart"
                  :close-on-content-click="false"
                  v-model="menuStartDate"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
              >
                <v-text-field
                    slot="activator"
                    v-model="form.startDate"
                    label="到款时间(起始)"
                    clearable
                    hint="格式YYYY-MM-DD, 如：2018-10-01"
                    persistent-hint
                />
                <v-date-picker
                    v-model="startDate"
                    locale="zh-cn"
                    @change="nv => form.startDate= nv"
                />
              </v-menu>
            </v-flex>

            <v-flex xs12 sm3>
              <v-menu
                  ref="refGrantDateEnd"
                  :close-on-content-click="false"
                  v-model="menuEndDate"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
              >
                <v-text-field
                    slot="activator"
                    v-model="form.endDate"
                    label="到款时间(截止)"
                    clearable
                    hint="格式YYYY-MM-DD, 如：2018-10-01"
                    persistent-hint
                />
                <v-date-picker
                    v-model="endDate"
                    locale="zh-cn"
                    @change="nv => form.endDate= nv"
                />
              </v-menu>
            </v-flex>

          </v-layout>
        </v-flex>
        <v-flex d-flex xs2 text-xs-center>
          <div>
            <v-btn color="primary" @click="onSearch">
              <v-icon dark>search</v-icon>
              检索
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-divider/>

    <v-data-table
        :headers="headers"
        :loading="loading"
        item-key="dbid"
        :pagination.sync="query"
        :items="pageResult.items"
        :total-items="pageResult.total"
        :rows-per-page-items="[10, 25, 50, 100, 200]"
    >
      <template slot="items" slot-scope="props">
        <td>
          {{ props.index + 1 }}
        </td>

        <td>
          <strong>{{ props.item.project? props.item.project.name : "" }}</strong>
          <br>
          {{ props.item.projType? props.item.projType.name : "" }}
        </td>

        <td>
          <strong>{{ props.item.projLeader? props.item.projLeader.name : "" }} &nbsp;
            {{ props.item.projLeader? props.item.projLeader.number : "" }} </strong>
          <br/>
          {{ props.item.projDept? props.item.projDept.name : "" }}
        </td>

        <td>
          {{ props.item.drawee }}
        </td>

        <td>
          {{ props.item.paymentDate }}
          <br>
          {{ props.item.budgetFile }}
        </td>

        <td>
          {{ props.item.amount | currency }}
        </td>

        <td>
          {{ props.item.researchFund | currency }}
        </td>

      </template>
    </v-data-table>

  </v-card>
</template>
<script>
import {mapGetters} from 'vuex'


import mixin from '@/mixin'

const baseUri = '/api/proj/fund/income/search/personal';
const statusUri = '/api/code/status';
const deptUri = '/api/syst/department';
const typeUri = '/api/proj/project-type/';

const startYear= new Date().getFullYear()

export default {
  // 混入模块列表页面（index）基本功能
  mixins: [mixin.index(baseUri)],

  components: {},

  data() {
    return {
      uri: baseUri,

      // 检索、分页、排序条件条件
      query: {
        startDate: `${startYear}-01-01`,
        endDate: new Date().toISOString().split('T')[0],
        deptId: '',

        page: 1,
        rowsPerPage: 25,
        sortBy: null,
        descending: null,
        totalItems: null
      },

      // 检索框
      form: {
        startDate: `${startYear}-01-01`,
        endDate: new Date().toISOString().split('T')[0],
        deptId: '',
      },

      statusItems: [],
      deptItems: [],
      typeItems: [],

      menuStartDate: false,
      startDate: null,

      menuEndDate: false,
      endDate: null,

      // 表头
      headers: [
        {text: '#', align: 'left', sortable: false, value: 'dbid', width: "2rem"},
        {text: '项目名称 / 类型', align: 'left', sortable: true, value: 'project'},
        {text: '项目负责人 / 工号 / 归属部门', align: 'left', sortable: true, value: 'projLeader'},
        {text: '汇款单位', align: 'left', sortable: true, value: 'drawee'},
        {text: '来款时间 / 预算文件及文号', align: 'left', sortable: true, value: 'paymentDate'},
        {text: '到款金额', align: 'left', sortable: true, value: 'amount'},
        {text: '留校研究经费', align: 'left', sortable: true, value: 'researchFund'},
      ],


      rowIdx: null,

      rules: {
        startDate: [
          v => !!v || "必填项。",
          v => window.xutil.regexpDate().test(v) || '日期格式错误'
        ],
        endDate: [
          v => !!v || "必填项。",
          v => (v && window.xutil.regexpDate().test(v)) || '日期格式错误',
          v => (v && v > this.form.grantDateStart) || "截止日期必须晚于起始日期。"
        ]
      }
    }
  },

  created() {
    // 加载审核状态
    this.axios.all([
      this.axios.get(statusUri, {params: {sort: 'rank.asc'}}),
      this.axios.get(deptUri, {params: {limit: 65535, disabled: 'F', sort: 'rank.asc'}}),
      this.axios.get(typeUri, {params: {limit: 65535, disabled: 'F', sort: 'rank.asc'}}),
    ]).then(
        this.axios.spread(
            (rspStaus, rspDept, rspType) => {
              this.statusItems = rspStaus.data.items;
              this.deptItems = rspDept.data.items;
              this.typeItems = rspType.data.items;
            }
        )
    )
  },

  computed: {
    ...mapGetters(['funcIds']),
    excelUrl() {
      // window.console.log(this.form);
      const url = '/api/proj/fund/income/exp/fmt/excel/personal';
      return window.xutil.buildUrl(url, Object.assign({limit: -1}, this.form))
    },
  },

  methods: {
    // 检索响应函数
    onSearch() {
      Object.assign(this.query, this.form);
      this.query.page = 1;
      this.doRoute(this.query);
    }
  }
}
</script>
